import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type ProfileStateType = {
    portfolio: Portfolio[] | null;
    pnl: Pnl[] | null;
    settings: any;
    selectedIndex: number | null;
    loadedPortfolio: Boolean;
    tax: number | null;
    isNew: Boolean;
}

interface Coin {
    id: number;
    icon: string;
    name: string;
}

interface PortfolioItem {
    coin: Coin;
    weight: number;
}

export interface PnlItem {
    coin: Coin;
    currentPrice: number;
    currentVolume: number;
    weight: number;
    pnl: number;
    startPrice: number;
    startVolume: number;
    yield: number;
    name: string;
}

export interface Portfolio {
    description: string;
    id: number;
    items: PortfolioItem[];
    name: string;
    weight: number;
}

export interface Pnl {
    currentPrice: number;
    currentVolume: number;
    description: string;
    id: number;
    items: PnlItem[];
    name: string;
    weight: number;
    pnl: number;
    startPrice: number;
    startVolume: number;
    yield: number;
}

let initialState: ProfileStateType = {
    portfolio: [],
    pnl: [],
    settings: {},
    selectedIndex: null,
    loadedPortfolio: false,
    tax: 0,
    isNew: false
}

const profileSlice = createSlice({
    name: 'profileStoreModule',
    initialState,
    reducers: {
        getUserPortfolio: (state, action: PayloadAction<any>) => {
            state.pnl = action.payload.pnl;
            state.portfolio = action.payload.portfolio;
            state.tax = action.payload.tax_value_ils ?? {};
            state.settings=Object.assign({min_deposit_nis_value: action.payload.min_deposit_nis_value},
                action.payload.settings && Object.keys(action.payload.settings).length?action.payload.settings:action.payload.platform_settings);
            state.isNew = action.payload.data?.isNew ?? false;
        },
        changeSelectedIndex: (state, action: PayloadAction<number>) => {
            state.selectedIndex = action.payload;
        },

        updateLoadedPortfolio: (state, action: PayloadAction<any>) => {
            state.loadedPortfolio = action.payload.loadedPortfolio;
        },

        resetProfileState(state){
            Object.assign(state, initialState);
        }
    }
})

export const {
    getUserPortfolio,
    changeSelectedIndex,
    resetProfileState,
    updateLoadedPortfolio
} = profileSlice.actions

export const ProfileReducer = profileSlice.reducer
